/**
 * Truncates an amount for display. If the number is in the millions, an 'M' is
 * appended. If it is in the thousands, a 'K' is appended.
 * @param amount The amount to truncate
 * @returns {string} The truncated amount as a string
 */
export default function truncateAmount (amount) {
  // if > 1 million :
  // display x.xxM if less than 10 million
  // display xx.xM if greater than 10 million
  if (amount >= 1000000) {
    let quotient = amount / 1000000
    return (isDecimal(quotient) ? quotient.toFixed(quotient > 10 ? 1 : 2) : quotient) + 'M'
  } else if (amount >= 1000) {
    // if < 1 million:
    // display x[xx]K
    let quotient = (amount / 1000)
    return (isDecimal(quotient) ? quotient.toFixed(1) : quotient) + 'K'
  } else {
    return (isDecimal(amount) ? amount.toFixed(1) : amount)
  }
}

function isDecimal (num) {
  return num % 1 !== 0
}



// WEBPACK FOOTER //
// ./src/app/filters/truncateAmount.js